module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/smoothie@2x_c11869.jpg";